import {FileModel} from "./models";

//
//basic definition of products and carts
//

export interface ProductJSON {
  uuid: string,
  name: string,
  quantity: number,
  max_quantity: number,
  list_price: number,
  unit_price: number
}

export class ProductModel {
  uuid: string;
  name: string;
  quantity: number;
  maxQuantity: number;
  listPrice: number;
  unitPrice: number;

  constructor(
    uuid: string,
    name: string,
    quantity: number,
    maxQuantity: number,
    listPrice: number,
    unitPrice: number
  ) {
    this.uuid = uuid;
    this.name = name;
    this.quantity = quantity;
    this.maxQuantity = maxQuantity;
    this.listPrice = listPrice;
    this.unitPrice = unitPrice;
  }
}

export class ProductFactory {

  fromJSON(json: ProductJSON): ProductModel {
    return new ProductModel(
      json.uuid,
      json.name,
      json.quantity,
      json.max_quantity,
      Number(json.list_price),
      Number(json.unit_price)
    );
  }

  toJSON(model: ProductModel): ProductJSON {
    return {
      uuid: model.uuid,
      name: model.name,
      quantity: model.quantity,
      max_quantity: model.maxQuantity,
      list_price: model.listPrice,
      unit_price: model.unitPrice
    }
  }
}


/************************************************/
/************************************************/
/************************************************/

export interface EventJSON {
  uuid: string,
  name: string,
  date: Date,
  country: string,
  regions: string[],
  circle_types: string[]
}

export class EventModel {
  uuid: string;
  name: string;
  date: Date;
  country: string;
  regions: string[];
  circleTypes: string[];

  constructor(
    uuid: string,
    name: string,
    date: Date,
    country: string,
    regions: string[],
    circleTypes: string[]
  ) {
    this.uuid = uuid;
    this.name = name;
    this.date = date;
    this.country = country;
    this.regions = regions;
    this.circleTypes = circleTypes;
  }
}

export class EventFactory {

  fromJSON(json: EventJSON): EventModel {
    return new EventModel(
      json.uuid,
      json.name,
      json.date,
      json.country,
      json.regions,
      json.circle_types
    );
  }

  toJSON(model: EventModel): EventJSON {
    return {
      uuid: model.uuid,
      name: model.name,
      date: model.date,
      country: model.country,
      regions: model.regions,
      circle_types: model.circleTypes
    }
  }
}

/************************************************/
/************************************************/
/************************************************/

export interface EventProductJSON {
  event: EventJSON,
  products: ProductJSON[]
}

export class EventProductModel {
  event: EventModel;
  products: ProductModel[];

  constructor(
    event: EventModel,
    products: ProductModel[]
  ) {
    this.event = event;
    this.products = products;
  }
}

export class EventProductFactory {

  fromJSON(json: EventProductJSON): EventProductModel {
    const productFactory = new ProductFactory();
    const eventFactory = new EventFactory();
    return new EventProductModel(
      eventFactory.fromJSON(json.event),
      json.products.map((thisProduct: ProductJSON) => productFactory.fromJSON(thisProduct))
    );
  }

  toJSON(model: EventProductModel): EventProductJSON {
    const productFactory = new ProductFactory();
    const eventFactory = new EventFactory();
    return {
      event: eventFactory.toJSON(model.event),
      products: model.products.map((thisProduct: ProductModel) => productFactory.toJSON(thisProduct))
    }
  }
}

/************************************************/
/************************************************/
/************************************************/

export interface CartAJSON {
  event_products: EventProductJSON[],
  other_products: ProductJSON[],
  selected_product_uuids: string[],
  total_price: number
}

export class CartAModel {
  eventProducts: EventProductModel[];
  otherProducts: ProductModel[];
  selectedProductUuids: string[];
  totalPrice: number;

  constructor(
    eventProducts: EventProductModel[],
    otherProducts: ProductModel[],
    selectedProductUuids: string[],
    totalPrice: number
  ) {
    this.eventProducts = eventProducts;
    this.otherProducts = otherProducts;
    this.selectedProductUuids = selectedProductUuids;
    this.totalPrice = totalPrice;
  }
}

export class CartAFactory {

  init(): CartAModel {
    const emptyCart = new CartAModel([],[],[],0.)
    return emptyCart
  }

  fromJSON(json: CartAJSON): CartAModel {
    const productFactory = new ProductFactory();
    const eventProductFactory = new EventProductFactory();
    return new CartAModel(
      json.event_products.map((thisEventProduct: EventProductJSON) => eventProductFactory.fromJSON(thisEventProduct)),
      json.other_products.map((thisProduct: ProductJSON) => productFactory.fromJSON(thisProduct)),
      json.selected_product_uuids,
      json.total_price
    );
  }

  toJSON(model: CartAModel): CartAJSON {
    const productFactory = new ProductFactory();
    const eventProductFactory = new EventProductFactory();
    return {
      event_products: model.eventProducts.map((thisEventProduct: EventProductModel) => eventProductFactory.toJSON(thisEventProduct)),
      other_products: model.otherProducts.map((thisProduct: ProductModel) => productFactory.toJSON(thisProduct)),
      selected_product_uuids: model.selectedProductUuids,
      total_price: model.totalPrice
    }
  }
}
